module.exports = __webpack_public_path__ + "img/1f601.889914a.svg";